import Addon from '../classes/addon';
import Event from '../classes/event';
import { ParentalAge, ParentalTimeFrames } from '../types/enums/parental';
import { store } from '../store/store';

const ParentalUtils = {
  checkParentalControl(
    event: Addon | Event | undefined,
    callback?: () => void
  ) {
    const {
      user: { parental },
    } = store.getState();
    if (
      parental?.pin &&
      parental?.enabled &&
      (ParentalUtils.isAdultRestricted(event) ||
        (ParentalUtils.isTimeRestricted(parental?.timeFrames) &&
          ParentalUtils.isAgeRestricted(event?.ageCode)))
    ) {
      if (callback) callback();
      return true;
    }
    return false;
  },
  isAdultRestricted(event: Addon | Event | undefined) {
    const { user } = store.getState();
    return (
      user.parental?.enabled &&
      ((event as Addon)?.parentalControl ||
        (event as Event)?.channel?.parentalControl ||
        event?.ageCode === ParentalAge.ADULTS)
    );
  },
  isAgeRestricted(assetAge: ParentalAge | undefined) {
    if (!assetAge) return false;
    const { user } = store.getState();
    assetAge = assetAge.toUpperCase().replace('+', '') as ParentalAge;

    switch (user.parental?.age) {
      case ParentalAge.SEVEN:
        return [
          ParentalAge.TWELVE,
          ParentalAge.SIXTEEN,
          ParentalAge.EIGHTEEN,
          ParentalAge.ADULTS,
        ].includes(assetAge);
      case ParentalAge.TWELVE:
        return [
          ParentalAge.SIXTEEN,
          ParentalAge.EIGHTEEN,
          ParentalAge.ADULTS,
        ].includes(assetAge);
      case ParentalAge.SIXTEEN:
        return [ParentalAge.EIGHTEEN, ParentalAge.ADULTS].includes(assetAge);
      case ParentalAge.EIGHTEEN:
      case ParentalAge.ADULTS:
        return assetAge === ParentalAge.ADULTS;
    }

    return false;
  },
  isTimeRestricted(timeFrames: ParentalTimeFrames[] | undefined) {
    if (!timeFrames || !timeFrames.length) {
      return false;
    }

    const currentHour = new Date().getHours();

    if (
      currentHour >= 7 &&
      currentHour < 14 &&
      timeFrames?.includes(ParentalTimeFrames.MORNING)
    ) {
      return true;
    }
    if (
      currentHour >= 14 &&
      currentHour < 21 &&
      timeFrames?.includes(ParentalTimeFrames.AFTERNOON)
    ) {
      return true;
    }
    if (
      (currentHour >= 21 || currentHour < 7) &&
      timeFrames?.includes(ParentalTimeFrames.NIGHT)
    ) {
      return true;
    }

    return false;
  },
};

export default ParentalUtils;
